import React, { createContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ModalContext = createContext();

const defaultSettings = {
	// Asset
	addAsset: false,
	viewAsset: false,
	manageAttributes: false,

	// Location
	addLocation: null,

	// Logs
	viewLog: null,

	// Generic
	deleteModal: false,
	globalSearch: false,
	selectLocation: false,
	selectContacts: false,
	uploadDocuments: false,

	// Tickets
	addTicket: false,
	ticketsOverview: false,
	createTicket: false,

	// Contacts
	addContact: false,
	viewProfile: false,
	viewContact: false,
	addVendorModal: false,

	// Servuces
	serviceOverview: false,
	eventDetails: false,
	taskCompletedModal: false,

	//Contracts
	contractOverview: false,

	// Bookings
	addBooking: false,
	bookingOverview: false,

	// Tablet
	tabletView: false,

	// Table
	manageColumns: false,
	tableCSVExport: false,

	// Consumables
	viewConsumable: false,
	addConsumable: false,

	// Categories
	addCategoryModal: false,

	// Tags
	addTagModal: false,

	uploadContractPdfModal: false,
	addContractServiceModal: false,

	addPowerUser: false,
	addOrganization: false,
	addAssetToOrganization: false,

	addContentBlock: false,

	// Assets
	assetModal: false, // entry modal
	assetModalForm: false, // creating a single asset modal

	customField: false,

	// Sliders
	nearbyAssets: false,
};

function removeModal(names, nameToRemove) {
	return names.filter((name) => name?.name !== nameToRemove);
}

export const ModalProvider = ({ children }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const [currentOpen, setCurrentOpen] = useState(defaultSettings);
	const [activeModals, setActiveModals] = useState([]);

	const setOpen = (modal, value, cb, opts) => {
		console.log('SET OPEN', modal, value);

		if (value !== undefined && !value) {
			if (activeModals?.length > 0) {
				const pulledDetails = currentOpen[modal];

				if (pulledDetails?.path) {
					navigate(pulledDetails?.path, { replace: true });
				} else {
					navigate(location.pathname, { replace: true });
				}
			} else {
				if (modal?.path) {
					navigate(modal?.path);
				}
			}
			setActiveModals(removeModal(activeModals, modal));
		} else {
			setActiveModals((prevStack) => [...prevStack, value]);
		}
		setCurrentOpen((prevCurrentOpen) => ({
			...prevCurrentOpen,
			[modal]: value !== undefined ? value : true,
		}));

		if (typeof cb === 'function') {
			cb();
		}
	};

	useEffect(() => {
		const handlePopState = (a) => {
			if (activeModals.length > 0) {
				const modalDetails = activeModals[activeModals?.length - 1];
				setOpen(modalDetails?.name, false, modalDetails, null, currentOpen);
			}
		};
		window.addEventListener('popstate', handlePopState);
		return () => window.removeEventListener('popstate', handlePopState);
	}, [activeModals]);

	const isOpen = (modal) => {
		return currentOpen[modal];
	};

	return (
		<ModalContext.Provider
			value={{
				open: currentOpen,
				setOpen,
				isOpen,
				getActive: currentOpen,
			}}
		>
			{children}
		</ModalContext.Provider>
	);
};

export const AppConsumer = ModalContext.Consumer;

export default ModalContext;
